import { Router } from '@angular/router';
import { OverlayService } from '../../core/overlay.service';
import { ConfigurationsService } from '../../configurations.service';
import { RoutesService } from '../../routes.service';
import { AuthenticationService } from '../../authentication.service';
import { UserService } from '../../user.service';
/**
 * This component represents the main menu of the application.
 */
var MenuComponent = /** @class */ (function () {
    /**
    * Creates an instance of MenuComponent.
    * @param {AuthenticationService} authenticationService
    * @param {ConfigurationsService} configurationsService
    * @param {Router} router
    * @param {OverlayService} overlayService
    * @param {RoutesService} routesService
    * @memberof MenuComponent
    */
    function MenuComponent(authenticationService, userService, configurationsService, router, overlayService, routesService) {
        this.authenticationService = authenticationService;
        this.userService = userService;
        this.configurationsService = configurationsService;
        this.router = router;
        this.overlayService = overlayService;
        this.routesService = routesService;
        /**
         * Gets or sets a boolean flag indicating whether the menu is open or not.
         * Important to known when the application runs on a small device.
         */
        this.menuOpen = false;
    }
    MenuComponent.prototype.routes = function () {
        return this.configurationsService.configurations.app.routes;
    };
    MenuComponent.prototype.isMenuItemActive = function (menuItem) {
        return this.router.url.startsWith('/' + menuItem.path);
    };
    MenuComponent.prototype.isSubMenuItemActive = function (menuItem) {
        return (this.router.url.startsWith(menuItem.link));
    };
    MenuComponent.prototype.goTo = function (event, menuItem) {
        event.stopPropagation();
        this.router.navigateByUrl(menuItem.link);
        if (this.isMenuOpen()) {
            this.toggleMenu();
        }
    };
    /**
     * To toggle the open state of the menu.
     * Important when the application runs on a small device.
     */
    MenuComponent.prototype.toggleMenu = function () {
        this.menuOpen = !this.menuOpen;
    };
    /**
     * Gets the open state of the menu
     * @returns True when the menu is open otherwise false.
     */
    MenuComponent.prototype.isMenuOpen = function () {
        return this.menuOpen;
    };
    /**
     * Initiates the creation of the account overlay
     */
    MenuComponent.prototype.openAccount = function () {
        console.log('menu-openAccount');
        this.overlayService.goToEntity(this.userService.user);
    };
    /**
     * Initiates the creation of the view profile overlay
     */
    MenuComponent.prototype.viewProfile = function () {
        console.log('menu-viewProfile');
        this.overlayService.goToEntity(this.userService.user.Resource);
    };
    /**
    * Perform log out from authentication service
    */
    MenuComponent.prototype.doLogout = function (event) {
        event.stopPropagation();
        this.authenticationService.logOut();
    };
    return MenuComponent;
}());
export { MenuComponent };
